export default __webpack_public_path__ + "static/media/wishlist.32789a1c.svg";